import React, { useState } from "react";

const Test = () => {
  const [rawJson, setRawJson] = useState("");
  const [beautifiedJson, setBeautifiedJson] = useState("");

  const handleRawJsonChange = (e) => {
    setRawJson(e.target.value);
  };

  const beautifyJson = () => {
    try {
      const parsedJson = JSON.parse(rawJson);
      const formattedJson = JSON.stringify(parsedJson, null, 2); // 2 is for indentation
      setBeautifiedJson(formattedJson);
    } catch (error) {
      setBeautifiedJson("Invalid JSON format!");
    }
  };

  return (
    <div className="json-beautifier">
      <h1>JSON Beautifier</h1>

      <div>
        <h2>Enter Raw JSON</h2>
        <textarea
          value={rawJson}
          onChange={handleRawJsonChange}
          placeholder="Paste your raw JSON here..."
          rows="10"
          cols="50"
        />
      </div>

      <button onClick={beautifyJson}>Beautify JSON</button>

      <div>
        <h2>Beautified JSON</h2>
        <textarea
          value={beautifiedJson}
          readOnly
          rows="10"
          cols="50"
          style={{ backgroundColor: "#f0f0f0", fontFamily: "monospace" }}
        />
      </div>
    </div>
  );
};

export default Test;
